/**
 * Checks if an IP address is a local network address.
 * This includes loopback addresses, private network ranges, and 'localhost'.
 */
export const isLocalIp = (ip: string): boolean => {
  if (!ip) return false;

  const trimmedIp = ip.toLowerCase().trim();

  // localhost check
  if (trimmedIp === "localhost") return true;

  // IPv4 Loopback
  if (trimmedIp === "127.0.0.1") return true;

  // IPv4 Private Ranges
  // 10.0.0.0 – 10.255.255.255
  if (trimmedIp.startsWith("10.")) return true;

  // 172.16.0.0 – 172.31.255.255
  const ipv4Match = trimmedIp.match(/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/);
  if (ipv4Match) {
    const firstOctet = parseInt(ipv4Match[1], 10);
    const secondOctet = parseInt(ipv4Match[2], 10);
    if (firstOctet === 172 && secondOctet >= 16 && secondOctet <= 31) {
      return true;
    }
    // 192.168.0.0 – 192.168.255.255
    if (firstOctet === 192 && secondOctet === 168) {
      return true;
    }
  }

  return false;
};

/**
 * Augments fetch options with targetAddressSpace if the IP is local.
 * This is part of the Private/Local Network Access security model.
 */
export const getFetchOptions = (
  options: RequestInit,
  ip?: string,
): RequestInit => {
  if (ip && isLocalIp(ip)) {
    return {
      ...options,
      // @ts-expect-error - targetAddressSpace is not yet in standard RequestInit types
      targetAddressSpace: "private",
    };
  }
  return options;
};
